import type { AdministrationContentPage } from "@kontextwerk/control-web-frame/shared/logic/administration"

export const pageConfig: AdministrationContentPage = {
  id: "letter",
  title: "Briefvorlagen",
  path: "letter",
  tabs: [
    ["announcement", "Ankündigung"],
    ["reschedule", "Verschiebung"],
    ["aushang", "Aushang"],
    ["other", "Allgemein"],
  ].map(([purpose, title]) => ({
    id: `letter-${purpose}`,
    title,
    routeSegment: purpose.replaceAll("_", "-"),
    widthType: "normal",
    testId: `controlAdmin.organizationView.announcementTemplates.letter.${purpose}`,
  })),
}
